import * as React from 'react';
import { Collapse } from 'reactstrap';
import NavigationLink from './NavigationLink';
import { ISideBar } from 'src/modules/Routing/types';
import { isSidebarActive } from '../hooks/useIsRouteActive';

interface IMobileCollapseProps {
  toggle: () => void;
  handleOpen: boolean;
  mobileRoutes: ISideBar[];
}

export const MobileCollapse = ({ toggle, handleOpen, mobileRoutes }: IMobileCollapseProps) => {
  const isActive = isSidebarActive();
  return (
    <Collapse isOpen={handleOpen}>
      {mobileRoutes.map((mobileNav, i) => {
        const navigationLink = (
          <NavigationLink
            key={i}
            navTitle={mobileNav.navTitle}
            filterPath={mobileNav.path}
            isActive={isActive(mobileNav.route, mobileNav.path, mobileNav.isMainPath, mobileNav.modulePath)}
            handleClick={toggle}
            routePath={mobileNav.route}
          />
        );
        return (
          !mobileNav.hideOnMobile ?
            !mobileNav.isFormLink ?
              navigationLink :
              <div className="notification-links">{navigationLink}</div> :
            null
        )
      })}
    </Collapse>
  )
}


// WEBPACK FOOTER //
// ./src/modules/Navigation/NavBar/components/MobileCollapse.tsx